export type SpecAction = "prefetch" | "prerender";

export function injectSpeculationRules(action: SpecAction, urls: string[], debug = false): boolean {
  try {
    const script = document.createElement("script");
    script.type = "speculationrules";

    const payload: any = {};
    payload[action] = [{ source: "list", urls }];

    script.textContent = JSON.stringify(payload);
    document.head.appendChild(script);

    if (debug) console.log("[HyperInstant] speculationrules injected:", action, urls);
    return true;
  } catch {
    return false;
  }
}
